// Typelizer digest 2029b5117eb1b5b52b168e25daa8b3cd
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /c/:company_id/documents/:document_id/rebill */
  update: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/rebill', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/documents/:document_id/rebill */
  destroy: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/rebill', params, options),
    method: 'delete',
  }),
}
